import React from "react";

function Error({ message }) {
  return <div style={{ padding: "10px" }}>Error: {message}</div>;
}

export default Error;
